import { get } from 'lodash-es'

export default {
  data() {
    return {
      resourceKey: 'name',
      resourcePrefix: null,
      routes: {
        index: null,
        create: null,
        edit: null,
        view: null,
      },
    }
  },
  computed: {
    resourceName() {
      return get(this.resource, this.resourceKey, 'Unable to retrieve name')
    },
    isSingleResource() {
      return typeof this.resource === 'object'
    },
    isMultipleResources() {
      return typeof this.resources === 'object'
    },
    indexRoute() {
      if (this.routes.index !== null) return this.routes.index
      return `${this.resourcePrefix}`
    },
    createRoute() {
      if (this.routes.create !== null) return this.routes.create
      return `${this.resourcePrefix}.create`
    },
    editRoute() {
      if (this.routes.edit !== null) return this.routes.edit
      return `${this.resourcePrefix}.edit`
    },
    viewRoute() {
      if (this.routes.view !== null) return this.routes.view
      return `${this.resourcePrefix}.view`
    },
  },
  methods: {
    redirectToIndexView() {
      return { name: this.indexRoute }
    },
    redirectToCreateView() {
      this.$router.push({ name: this.createRoute })
    },
    redirectToEditView(id) {
      return { name: this.editRoute, params: { id } }
    },
    redirectToView(id) {
      return { name: this.viewRoute, params: { id } }
    },
  },
}
